import(/* webpackMode: "eager" */ "/codebuild/output/src1917090841/src/company/src/app/(service)/axis/page.tsx");
